import {
  getStore,
  setStore,
  removeStore
} from '@/utils/store'

const ClientDataKey = 'Xs_ClientData'
const UserDataKey = 'Xs_UserData'
const ProjectDataKey = 'Xs_ProjectData'

// 保存客户端信息
export const setClientData = data => {
  setStore({
    name: ClientDataKey,
    content: data,
    type: 'session'
  })
}
// 获取客户端信息
export const getClientData = () => {
  return getStore({
    name: ClientDataKey,
    type: 'session'
  })
}
// 获取应用id
export const getAppId = () => {
  return getClientData().appId
}
// 获取客户端类型
export const getClientType = () => {
  return getClientData().clientType
}
// 小程序判断
export const isMiniProgram = () => {
  return getClientType() === 4 || getClientType() === '4'
}
// 获取业态id
export const getIndustryId = () => {
  return getClientData().industryId
}
// 获取accessToken
export const getAccessToken = () => {
  return getClientData().accessToken
}
// 获取是否是业主端
export const getIsOwner = () => {
  return getClientData().isOwner || false
}
// 获取当前项目id
export const getProjectId = () => {
  return getClientData() && getClientData().projectId || getProjectId1()
}
// 获取状态栏高度
export const getStatusHeight = () => {
  if (getClientData() == undefined || getClientData() == null) {
    return 0
  }
  if (getClientData().statusHeight == undefined || getClientData().statusHeight == null) {
    return 0
  }
  return getClientData().statusHeight
}
// 获取从原生传过来的字体倍数
export const getRate = () => {
  if (getClientData() == undefined || getClientData() == null) {
    return 0
  }
  if (getClientData().rate == undefined || getClientData().rate == null) {
    return 0
  }
  return getClientData().rate
}
// 是否是中海城服app。针对中海城服app，处理完毕的描述为非必填
export const getIsZHCFApp = () => {
  if (getClientData() == undefined || getClientData() == null) {
    return 0
  }
  if (getClientData().isZHCF == undefined || getClientData().isZHCF == null) {
    return 0
  }
  return getClientData().isZHCF
}
// 保存用户信息
export const setUserData = data => {
  setStore({
    name: UserDataKey,
    content: data,
    type: 'session'
  })
}
// 获取用户信息
export const getUserData = () => {
  return getStore({
    name: UserDataKey,
    type: 'session'
  })
}
// 获取用户id
export const getUserId = () => {
  return getUserData().id
}
// 获取用户登录账号
export const getLoginName = () => {
  return getUserData().loginName
}
// 获取用户名字
export const getName = () => {
  return getUserData().name
}
// 获取用户手机号
export const getPhone = () => {
  return getUserData().phone
}
// 获取用户性别
export const getSex = () => {
  return getUserData().sex
}
// 获取用户年龄
export const getAge = () => {
  return getUserData().age
}
// 获取用户邮箱
export const getEmail = () => {
  return getUserData().email
}
// 获取用户企业id
export const getUserEnterpriseId = () => {
  return getUserData() && getUserData().enterpriseIds[0]
}

// 获取用户企业id
export const getUserEnterpriseName = () => {
  return getUserData().enterpriseName
}

// 保存项目信息
export const setProjectData = data => {
  setStore({
    name: ProjectDataKey,
    content: data,
    type: 'session'
  })
}

// 删除项目信息
export const removeProjectData = () => {
  return removeStore({
    name: ProjectDataKey
  })
}

// 获取项目信息
export const getProjectData = () => {
  return getStore({
    name: ProjectDataKey,
    type: 'session'
  })
}
// 获取项目名称
export const getProjectName = () => {
  return getProjectData() && getProjectData().name
}
// 获取项目id
export const getProjectId1 = () => {
  return (getProjectData() && getProjectData().projectId) || getClientData() && getClientData().projectId
}
// 获取项目归属企业id
export const getEnterpriseId = () => {
  return getProjectData() && getProjectData().enterpriseId
}
// 获取项目归属企业名字
export const getEnterpriseName = () => {
  return getProjectData().enterpriseName
}


// 园区活动报名位置信息保存
const CamSignAddrId = 'Xs_CamSignAddrId'
const CamSignAddrName = 'Xs_CamSignAddrName'
// 保存报名位置id
export const setCampusActivitySignAddrIdData = data => {
  setStore({
    name: CamSignAddrId,
    content: data,
    type: 'session'
  })
}
// 获取报名位置id
export const getCampusActivitySignAddrIdData = () => {
  return getStore({
    name: CamSignAddrId,
    type: 'session'
  })
}

// 保存报名位置名称
export const setCampusActivitySignAddrNameData = data => {
  setStore({
    name: CamSignAddrName,
    content: data,
    type: 'session'
  })
}
// 获取报名位置名称
export const getCampusActivitySignAddrNameData = () => {
  return getStore({
    name: CamSignAddrName,
    type: 'session'
  })
}


// 星启商管-招商管理-新增管理数据-页面显示数据
const InvesAddDate = 'Xs_InvesAddDate'
// 保存新增管理数据
export const setInvesAddDate = data => {
  setStore({
    name: InvesAddDate,
    content: data,
    type: 'session'
  })
}
// 获取新增管理数据
export const getInvesAddDate = () => {
  return getStore({
    name: InvesAddDate,
    type: 'session'
  })
}
// 删除新增管理数据
export const deleteInvesAddDate = () => {
  return removeStore({
    name: InvesAddDate
  })
}

// 以map方式保存新增管理数据
export const investAddData = function(title, detail) {
  let invesAddData = getInvesAddDate();
  let map;
  if (invesAddData == undefined || invesAddData == null) {
    map = new Map();
  } else {
    map = new Map(invesAddData)
  }
  map.set(title, detail);
  setInvesAddDate(map);
}


// 星启商管-招商管理-新增管理数据-create需要数据
const InvesAddDataCreate = 'Xs_InvesAddDataCreate'
// 保存新增管理create数据
export const setInvesAddDataCreate = data => {
  setStore({
    name: InvesAddDataCreate,
    content: data,
    type: 'session'
  })
}
// 获取新增管理create数据
export const getInvesAddDataCreate = () => {
  return getStore({
    name: InvesAddDataCreate,
    type: 'session'
  })
}
// 删除新增管理create数据
export const deleteInvesAddDataCreate = () => {
  return removeStore({
    name: InvesAddDataCreate
  })
}

// 保存新增管理create数据
export const investAddDataCreate = function(title, detail) {
  let invesAddData = getInvesAddDataCreate();
  if (invesAddData == undefined || invesAddData == null) {
    invesAddData = {};
  }
  invesAddData[title] = detail;

  setInvesAddDataCreate(invesAddData);
}

// H5标题
const h5Title = 'H5_title'
// 保存H5标题
export const setH5Title = data => {
  setStore({
    name: h5Title,
    content: data,
    type: ''
  })
}
// 获取H5标题
export const getH5Title = () => {
  return getStore({
    name: h5Title,
    type: ''
  })
}



// WEBPACK FOOTER //
// ./src/utils/user.js